
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { log } from 'console';
import { id } from 'date-fns/locale';
import * as Highcharts from "highcharts";
import { StockChart } from 'angular-highcharts';
import { LoggedUser } from 'src/backend/models/session-users/session-users';
import { BaseApi } from 'src/backend/api/base-api';
let Boost = require("highcharts/modules/boost");
let noData = require("highcharts/modules/no-data-to-display");
let More = require("highcharts/highcharts-more");

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
require("highcharts/modules/networkgraph")(Highcharts);

@Component({
  selector: 'app-save-chat-content',
  templateUrl: './save-chat-content.component.html',
  styleUrls: ['./save-chat-content.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class SaveChatContentComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() isNewSearch: boolean = false;
  @Input() newSearchData!: any;
  options!: StockChart;
  barOptions:any;
  chartOptions:any
  title = "HighChartNetworkGraph";
  chart: any;
  IsFlag: Boolean = false; 
  RandomNo:any; 
  groupedData:any;
  series: any []=[];
  uniqeName:any=[]
  distinctIntents: any=[];
  chartData: any = {};
  Type:string='column';
  chartArray: any[];
  chartType: any;
  userImage: any;
  blobStorage= Constants.BLOB_STORAGE_URL;
  uniqeNameForCharts: any = [];
  randomNumbForCharts: any = [];
  distincNames: any;
  chartItems: Array<string> = [];
  userProfile: LoggedUser;
  constructor(
    private baseApi: BaseApi,
  ) { }

  ngOnInit() { 
    // this.userImage = JSON.parse(localStorage.user)?.Pic;
    this.consol(this.data);
    this.getProfileInformation()
  } 
  trackBySearchData(index: number, searchData: any): any {
    return searchData.id;
  }
  getProfileInformation() {
    // this.userProfile = this.baseApi.getUserSession();
    // if (this.userProfile?.picture) {
    //   this.userImage = this.blobStorage + this.userProfile.picture;
    // } else {
    //   this.userImage = 'assets/images/img_avatar.png';
    // }
    this.userProfile = this.baseApi.getUserSession();
    this.userImage = this.userProfile?.picture;
  
  }

HandleArray(List, RandomNumber, Type,uniqueName) {
  
  if(Type === 'chart' && List?.chartType === 'analysis'){
    this.distinctIntents = List.responseContent.map(item => item.Date);
    this.chartType=List?.chartType
    this.uniqeName=Array.from(new Set(List?.responseContent.map(item => item.Name)));
    this.uniqeNameForCharts = this.uniqeName.slice();
    if(uniqueName !== '') return;
    const groupedData = List.responseContent.reduce((result, item) => {
      const name = item.Name;
      const value = parseFloat(item.Value);
      if (!result[name]) {
        result[name] = {
          name: name,
          data: [],
        };
      }
      result[name].data.push(value);
      return result;
    }, {});
    this.series = Object.values(groupedData);
    let a = this.series[0].data.map(Number);
    this.createChart(this.series,RandomNumber, this.chartType);
    // List.responseContent.forEach((item) => {
    //   item.Date = new Date(item.Date);
    // });
    // List.responseContent.sort((a, b) => a.Date - b.Date);
    // const groupedData = List.responseContent.reduce((result, item) => {
    //   const name = item.Name;
    //   const value = parseFloat(item.Value);
    //   if (!result[name]) {
    //     result[name] = {
    //       name: name,
    //       data: [],
    //     };
    //   }
    //   result[name].data.push([
    //     item.Date.getTime(),
    //     value,
    //   ]);
    //   return result;
    // }, {});
    // this.series = Object.values(groupedData);
    // this.createChart(this.series,RandomNumber, this.chartType);
  }
  else if (Type === 'chart' && List?.chartType === 'comparison') {
    this.distinctIntents = List.responseContent.map((item) => item.Date);
    this.chartType = List?.chartType;
    this.uniqeName = Array.from(
      new Set(List?.responseContent.map((item) => item.Name))
    );
    if (List.module === 'productivity') {
      const groupedData = List.responseContent.reduce((result, item) => {
        const name = item.Intent;
        const value = parseFloat(item.Value);
        if (!result[name]) {
          result[name] = {
            name: name,
            data: [],
          };
        }
        result[name].data.push(value);
        return result;
      }, {});
      this.series = Object.values(groupedData);
      let a = this.series[0].data.map(Number);
      this.createChart(this.series,RandomNumber, this.chartType);
    } else if (List.module === 'kpi') {
      const groupedData = List.responseContent.reduce((result, item) => {
        const name = item.Name;
        const value = parseFloat(item.Value);
        if (!result[name]) {
          result[name] = {
            name: name,
            data: [],
          };
        }
        result[name].data.push(value);
        return result;
      }, {});

      this.series = Object.values(groupedData);
      this.createChart(this.series,RandomNumber, this.chartType);
    }
  }
  else if(Type === 'chart' && List?.chartType === 'bar'){
    this.distinctIntents = List.responseContent.map((item) => item.Intent);
    this.distincNames = List.responseContent.map((item) => item.Entity);
    this.chartType = List?.chartType;
    const groupedData = List.responseContent.reduce((result, item) => {
      const name = item.Intent;
      const value = parseFloat(item.Value);
      if (!result[name]) {
        result[name] = {
          name: name,
          data: [],
        };
      }
      result[name].data.push(value);
      return result;
    }, {});

    this.series = Object.values(groupedData);
    let a = this.series[0].data.map(Number);
    // setTimeout(() => {
    this.createChart(this.series,RandomNumber, this.chartType);
  // }, 200);
    // this.createCharts(List,RandomNumber,Type);
  }
  else if (Type === 'list') {
    
    this.CreateTable(List); 
  } else {
    alert('Unsupported chart type');
  }
}
  consol(d:any){  
    console.log("From Save chat ngoninit");
    console.log(d);
  }
  createChart(d,i,t) {
    
    this.chartArray = [];
    const chartTypeMap = {
      'chart/list':'column',
      'line': 'line',
      'analysis': 'line',
      'comparison': 'line',
      'bar': 'column',
      'pie': 'pie',
    };
    this.Type = chartTypeMap[t.toLowerCase()] || 'column';
    if(t == 'analysis'){
      let index = 0;
      d.forEach((d) => {
        const chartObj = { id: '', chartOption: {} };
      this.barOptions ={
        chart: {
          type: this.Type
        },
        title: null,
        subtitle: null,
        credits: {
          enabled: false
        },
        xAxis: {
          categories: this.distinctIntents,
          crosshair: true,
          type: 'datetime',
        },
       
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [d]
      };
      this.chart = Highcharts.chart('container_'+this.randomNumbForCharts[index], this.barOptions); 
      index++;
      // chartObj.chartOption = this.options;
      // this.chartArray.push(chartObj);
      });
    }
    else if(t == 'comparison'){
      const chartObj = { id: '', chartOption: {} };
      this.barOptions = {
        chart: {
          type: this.Type
        },
        title: null,
        subtitle: null,
        credits: {
          enabled: false
        },
        rangeSelector: {
          enabled: false,
        },
        xAxis: {
          categories: this.distinctIntents,
          crosshair: false,
          type: 'datetime',
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: d
      };
      this.chart = Highcharts.chart('container_'+this.RandomNo, this.barOptions); 
    //   chartObj.chartOption = this.options;
    // this.chartArray.push(chartObj);
    // console.log(this.chartArray,'heooodsfasljflsd')
    }
    else {
      const chartObj = { id: '', chartOption: {} };
      this.barOptions = {
        chart: {
          type: this.Type
        },
        title: null,
        subtitle: null,
        credits: {
          enabled: false
        },
        xAxis: {
          categories: this.distincNames,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Values'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormatter: function () {
            var formattedValue = this.y;
            if (this.series.name === 'waste') {
              // For 'waste' series, don't show the percentage sign
              formattedValue = this.y.toFixed(1); // Format without percentage
            } else {
              // For other series, show the percentage sign
              formattedValue = '<b>' + this.y.toFixed(1) + ' %</b>'; // Format with percentage
            }
            return '<tr><td style="color:' + this.series.color + ';padding:0">' + this.series.name + ': </td>' +
              '<td style="padding:0">' + formattedValue + '</td></tr>';
          },
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: d
      };
      this.chart = Highcharts.chart('container_'+this.RandomNo, this.barOptions); 
      // chartObj.chartOption = this.barOptions;
      // this.chartArray.push(chartObj);
      // console.log('helo data',this.chartArray)
    }
  }

  CreateTable(data) {
    if (data.length === 0) {
      return; // No data to display
    }
    const headers = Object.keys(data.responseContent[0]).filter(header => header !== 'Chart'); // Get the keys from the first item in the data
    let tableHTML = '<table style="border-collapse: collapse; width: 100%; border: 1px solid #e0e0e0;">'; // Add inline CSS for table styling
    // Create table headers (th) based on the extracted headers
    tableHTML += '<thead style="background-color: #f2f2f2;">'; // Add a light gray header background
    tableHTML += '<tr>';
  
    for (const header of headers) {
      tableHTML += `<th style="border: 1px solid #e0e0e0; padding: 8px;">${header}</th>`;
    }
  
    tableHTML += '</tr>';
    tableHTML += '</thead>';
  
    // Iterate through the provided data and create table rows (tr) with data cells (td)
    tableHTML += '<tbody>';
  
    for (const item of data.responseContent) {
      tableHTML += '<tr>';
  
      for (const header of headers) {
        tableHTML += `<td style="border: 1px solid #e0e0e0; padding: 8px;">${item[header]}</td>`;
      }
  
      tableHTML += '</tr>';
    }
  
    tableHTML += '</tbody>';
  
    tableHTML += '</table>';
    // Insert the table HTML into the div with id "tableContainer"
  const tableContainer = document.getElementById('container_'+this.RandomNo);
  if (tableContainer) {
    tableContainer.innerHTML = tableHTML;
  }
  }
  generateRandomNumber(type: string, index: number) {
    const min = 0;
    const max = 999999;
    const randomNo = Math.floor(Math.random() * (max - min + 1)) + min;
    
    if (type === 'Analysis') {
      this.randomNumbForCharts[index] = randomNo;
    } else {
      this.RandomNo = randomNo;
    }
  }
  getItemsForPrint(items: string){
    this.chartItems = [];
    this.chartItems = items.split('/');
  }
}
